<template>
  <el-dialog
  width="900px"
  top="5vh"
  @open="dialogOpen"
  :before-close="handleClose"
  :close-on-click-modal="false"
  :visible.sync="visible">
    <div v-if="operateStatus === 0" class="main-container">
      <div class="tip-wrap">
        <div class="tip-image">
          <img src="@/assets/image/02.png" alt="logo">
        </div>
        <div class="tip-text-wrap">
          <div class="tip-text">
            成绩检查上报前可“拆分科目”
          </div>
          <div class="tip-text-small">
            例如：“理综”可以拆分为 “物理”、“化学”、“生物”
          </div>
        </div>
      </div>
      <div class="radio-oprate-wrap">
        <div class="radio-wrap" @click="cancelSplitSubject" :class="radioExtendClass1">
          <div class="radio-wrap-inner">
            <div style="margin-left:40px;margin-bottom:4px;">
              <el-radio v-model="splitSubjectStatus" label="0">{{blank}}</el-radio>
            </div>
            <div class="tip-text-big">不拆</div>
            <div class="tip-text-subject">科目</div>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <img :src="imageNoSplit">
          </div>
        </div>
        <div class="radio-wrap" @click="splitSubject" style="margin-left:40px;" :class="radioExtendClass2">
          <div class="radio-wrap-inner">
            <div style="margin-left:40px;margin-bottom:4px;">
              <el-radio :disabled="isNewGK" v-model="splitSubjectStatus" label="1">{{blank}}</el-radio>
            </div>
            <div class="tip-text-big">拆分</div>
            <div class="tip-text-subject">科目</div>
            <div v-if="splitSubjectStatus === '1'" style="margin-left: 70px;">
               <el-button type="success" @click="splitSubject" icon="el-icon-edit" plain>编辑</el-button>
            </div>
          </div>
           <div style="display: flex;justify-content: flex-end;">
            <img :src="imageSplit">
          </div>
        </div>
      </div>
    </div>
    <div v-if="operateStatus === 1" class="main-container">
      <score-level-param ref="ScoreGradeLevel"
        :enable-score-level="enableScoreLevel"
        :wen-li-flag="wenliFlag"
        :wen-li-flag-text="wenliFlagText"
        :config-param="scoreLevelConfig"
        :score-level="scoreLevel"
        :total-score="itemsScoreInfo.totalScore" />
    </div>
    <div v-if="operateStatus === 2" class="main-container">
      <div class="process-wrap">
        <div style="margin-top: 186px;" type="circle">
          <el-progress type="circle" :width="200" color="#99CC33"  :stroke-width="15" :percentage="process"></el-progress>
        </div>
        <div style="position: absolute;top: 118px;" type="circle">
          <el-progress :show-text="false" type="circle" :width="350" color="#FF9900"  :stroke-width="10" :percentage="subjectWorkProcess"></el-progress>
        </div>
        <div class="process-bottom">
        </div>
        <div class="process-text" style="margin-top: -58px; margin-bottom: 10px; max-height: 200px; overflow: auto; width: 100%; text-align: center;" v-html="processText"></div>
        <div class="process-text omr" ref="omrScoreProcessText" style="max-height: 200px; overflow: auto; width: 100%; text-align: center;" v-html="omrScoreProcessText"></div>
      </div>
    </div>
    <div v-if="operateStatus === 3" class="main-container">
      <div class="split-list-container">
        <div class="split-row" v-for="(splitItem,splitItemIndex) in splitList" :key="splitItemIndex">
          <div>
            <el-select
            v-model="splitItem.subjectId"
            placeholder="科目"
            class="subject-wrap">
              <el-option
                v-for="item in subjectList"
                :disabled="item.selected"
                :key="item.subjectId"
                :label="item.subjectName"
                :value="item.subjectId">
              </el-option>
            </el-select>
          </div>
          <div class="split-items-info">
            <span>客观题：{{splitItem.omrItems.length}}题，共{{splitItem.omrScore}}分；</span>
            <span>主观题：{{splitItem.zgItems.length}}题，共{{splitItem.zgScore}}分；</span>
            <div>该科目共：<span>{{splitItem.omrScore+splitItem.zgScore}}</span>分</div>
          </div>
          <div class="split-oprate-wrap">
            <el-popover
              placement="bottom-end"
              :offset="82"
              v-model="splitItem.itemVisible"
              trigger="manual">
              <div class="item-list-wrap">
                <div class="item-list-title">
                  <span>客观题</span><span>已选：{{splitItem.omrItems.length}}题</span>
                </div>
                <el-checkbox-group class="item-list" v-model="splitItem.omrItems">
                  <div class="item" v-for="omr in itemList.omr" :key="omr.itemId">
                    <el-checkbox @change="computeSplitSubjectScore(splitItemIndex,'omr')" :label="omr.itemId" >{{omr.itemText}}</el-checkbox>
                  </div>
                </el-checkbox-group>
                <div class="item-list-title">
                   <span>主观题</span><span>已选：{{splitItem.zgItems.length}}题</span>
                </div>
                <el-checkbox-group class="item-list" v-model="splitItem.zgItems">
                  <div class="item"  v-for="zg in itemList.zg" :key="zg.itemId">
                    <el-checkbox @change="computeSplitSubjectScore(splitItemIndex,zg)" :label="zg.itemId" >{{zg.itemText}}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <el-button v-if="!splitItem.itemVisible"  slot="reference" type="success" @click="showItems(splitItemIndex)" icon="el-icon-edit-outline" plain>选择对应题目</el-button>
              <el-button v-else slot="reference" type="warning" @click="splitItem.itemVisible = !splitItem.itemVisible" icon="el-icon-caret-top" plain>点击确定题目</el-button>
            </el-popover>
            <div class="split-oprate">
              <div @click="addSplitSubject" class="split-add">
                <i style="font-weight: bolder;font-size: 14px;" title="" class="iconfont icon-iconjia"></i>
              </div>
              <div @click="subSplitSubject(splitItemIndex)" class="split-add">
                <i style="font-weight: bolder;font-size: 14px; margin-top: -1px;" title="" class="iconfont icon-iconjian"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="operateStatus === 4" class="main-container">
     <div class="check-info-wrap">
       <div class="title-wrap">
        <div style="font-size:18px;font-weight: bolder;width: 75px;">{{subjectName}}</div>
        <div style="display: flex;width: 73%;">
          &nbsp;(&nbsp;总分：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.zgScore+itemsScoreInfo.omrScore}}</div>分 =
          客观题：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.omrScore}}</div>分 +
          主观题：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.zgScore}}</div>分&nbsp;)
        </div>
        <div style="display: flex;">评阅：<div style="color:#FEA059;font-weight: bolder;width: 55px;">{{checkInfo.totalCnt}}</div>份答卷</div>
       </div>
       <div class="info-wrap">
         <div class="info-item">
          <div class="info-item-title">最高分</div>
          <div class="info-item-content">
            <div style="width: 216px;">最高分：{{checkInfo.maxScore}}分(
              <a @click="openView(maxScoreCntUrl)" href="javascript:void(0)" class="person-num">{{checkInfo.maxScoreCnt}}人</a>)
            </div>
            <div style="width: 260px;"> 客观题最高分：{{checkInfo.maxOmrScore}}分(
              <a href="javascript:void(0)" @click="openView(maxOmrScoreCntUrl)" class="person-num">{{checkInfo.maxOmrScoreCnt}}人</a>)
            </div>
            <div>主观题最高分：{{checkInfo.maxZgScore}}分(
              <a href="javascript:void(0)" @click="openView(maxZgScoreCntUrl)" class="person-num">{{checkInfo.maxZgScoreCnt}}人</a>)
            </div>
          </div>
          <div style="width: 216px;">主观题校验任务
            <a href="javascript:void(0)" @click="openGradeMonitor()" class="person-num">{{ subjectVerifyUndo }}</a>
          </div>
         </div>
         <div class="info-item">
          <div class="info-item-title">客观题</div>
          <div class="info-item-content">
            <div style="width: 216px;">单选题有多个做答：
              <a href="javascript:void(0)" @click="openView(sigleOmrExceptionCntUrl)" class="person-num">{{checkInfo.sigleOmrExceptionCnt}}人</a>
            </div>
            <div style="width: 260px;"> 客观题有做答零分：
              <a href="javascript:void(0)" @click="openView(omrScoreZeroCntUrl)" class="person-num">{{checkInfo.omrScoreZeroCnt}}人</a>
            </div>
            <div>客观题选中率：
              <a href="javascript:void(0)" @click="openView(examResultAnalysisUrl)" class="person-num" style="color:#FF7F00;"><i style="font-size: 18px;color:#FF7F00;" title="" class="iconfont icon-search"></i></a>
            </div>
          </div>
          <div style="width: 216px;">客观题校验任务
            <a href="javascript:void(0)" @click="openScanMonitor()" class="person-num">{{ objectVerifyUndo }}</a>
          </div>
         </div>
         <div class="info-item">
          <div class="info-item-title">主客相关</div>
          <div class="info-item-content">
            <div style="width: 400px;">主观题高分客观题低分：
              <a href="javascript:void(0)" @click="openView(zgScoreOverOmrCntUrl)" class="person-num">{{checkInfo.zgScoreOverOmrCnt}}人</a>
            </div>
            <div style="width: 260px;">客观题高分主观题低分：
              <a href="javascript:void(0)" @click="openView(omrScoreOverZgCntUrl)" class="person-num">{{checkInfo.omrScoreOverZgCnt}}人</a>
            </div>
          </div>
          <div class="info-item-content" style="height:10px;">
            <div class="info-item-content-tip" style="width: 400px;">有可能考生未用2B铅笔填涂，导致作答未被识别
            </div>
            <div class="info-item-content-tip" style="width: 260px;">有可能评卷教师误给了低分
            </div>
          </div>
         </div>
         <div v-if="isNewGK" class="info-item">
          <div class="info-item-title">其他校验</div>
          <div class="info-item-content">
            <div style="width: 400px;">选考组合校验：
              <a href="javascript:void(0)" @click="openView(studentSubjectEditUrl)" class="person-num">{{checkInfo.studentSubjectErrorCnt}}人</a>
            </div>
          </div>
          <div class="info-item-content" style="height:10px;">
            <div class="info-item-content-tip" style="width: 400px;">新高考模式，考生学选科目不足6科
            </div>
          </div>
         </div>
       </div>
     </div>
    </div>
    <div v-if="operateStatus === 5" class="main-container">
      <div class="check-info-wrap">
        <div class="title-wrap">
          <div style="font-size:18px;font-weight: bolder;width: 75px;">{{subjectName}}</div>
          <div style="display: flex;width: 73%;">
            &nbsp;(&nbsp;总分：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.zgScore+itemsScoreInfo.omrScore}}</div>分 =
            客观题：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.omrScore}}</div>分 +
            主观题：<div style="color:red;font-weight: bolder;">{{itemsScoreInfo.zgScore}}</div>分&nbsp;)
          </div>
        </div>
        <div style="flex-direction:row;justify-content: flex-start;" class="info-wrap">
          <div style="height: 100%;width: 100px;border-right: 1px solid rgb(216, 216, 201);display: flex;flex-direction: column;justify-content: center;align-items: center;font-size: 30px;">
            <div>检</div>
            <div>查</div>
            <div>项</div>
          </div>
          <div style="height:100%;justify-content: flex-start;" class="info-wrap">
            <div class="check-subject-item-wrap">
              <div class="check-subject-item">
                扫描进度
              </div>
              <div v-if="checkSubjectWorkInfo.scanProcess" style="color:green;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-circle-check"></i>&nbsp;&nbsp;完成
              </div>
              <div v-else style="color:red;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-warning-outline"></i>&nbsp;&nbsp;未完成
              </div>
            </div>
            <div v-if="cardType!=='2'" class="check-subject-item-wrap">
              <div class="check-subject-item">
                主观题进度
              </div>
              <div v-if="checkSubjectWorkInfo.readPaperProcess" style="color:green;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-circle-check"></i>&nbsp;&nbsp;完成
              </div>
              <div v-else style="color:red;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-warning-outline"></i>&nbsp;&nbsp;未完成
              </div>
            </div>
            <div v-else class="check-subject-item-wrap">
              <div class="check-subject-item">
                主观题进度
              </div>
              <div v-if="checkSubjectWorkInfo.recognitionProcess" style="color:green;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-circle-check"></i>&nbsp;&nbsp;完成
              </div>
              <div v-else-if="!checkSubjectWorkInfo.recognitionProcess" style="color:red;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-warning-outline"></i>&nbsp;&nbsp;未完成
              </div>
              <div v-else-if="!checkSubjectWorkInfo.recognitionException" style="color:red;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-warning-outline"></i>&nbsp;&nbsp;有识别异常未处理，
                <a style="color: red;" target="_blank" :href="recognitionUrl">去处理</a>
              </div>
            </div>
            <div class="check-subject-item-wrap">
              <div class="check-subject-item">
                标答和分值设置
              </div>
              <div v-if="checkSubjectWorkInfo.setAnwserAndScore" style="color:green;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-circle-check"></i>&nbsp;&nbsp;完成
              </div>
              <div v-else style="color:red;" class="check-subject-item">
                <i style="font-size:20px;font-weight:bolder;" class="el-icon-warning-outline"></i>&nbsp;&nbsp;未完成
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="submitDiabled" @click="submit" :loading="submitLoading">确 定</el-button>
        <el-button type="info" v-if="isDebug" @click="handleSkip">分步请求</el-button>
        <el-button type="info" v-if="isDebug" @click="clearstatOmrScoreFlag">重置omr计算成绩状态</el-button>
        <el-button type="info" @click="handleClose">取 消</el-button>
        <el-checkbox v-if="isDebug" v-model="skipSubjectCheck" style="margin-left: 10px;">跳过未完成校验</el-checkbox>
    </span>
    <div style="color:white;height: 24px;line-height: 24px;" slot="title">
      单科合分&nbsp;&nbsp;{{subjectName}}
    </div>
    <el-dialog
      title="提示"
      :visible.sync="stepVisible"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="760px">
      <div>
        <p style="text-align: center">
          当前: {{ activeEvent.stepName }}
        </p>
        <el-button type="success" v-if="zgKgConfigValue == 1" @click="setEvent('assignPJVM')">申请评卷资源</el-button>
        <el-button type="success" @click="setEvent('importOmrScan')">导入omr结果</el-button>
        <el-button type="success" @click="setEvent('statOmrScore')">计算omr成绩</el-button>
        <el-button type="success" @click="setEvent('resultCombine')">OMR成绩统分</el-button>
        <el-button type="success" @click="checkResultCombineProcess(activeEvent.resultCombineResult)">成绩合成进度查询</el-button>
        <div class="process-wrap">
          <div class="process-text" style="margin-top: 20px; margin-bottom: 10px; max-height: 200px; overflow: auto; width: 100%; text-align: center;" v-html="processText"></div>
          <div class="process-text omr" ref="omrScoreProcessText" style="max-height: 200px; overflow: auto; width: 100%; text-align: center;" v-html="omrScoreProcessText"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="stepVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
// 引入图片地址
import imageNoSplitUrl from '@/assets/image/split01.png'
import imageNoSplitUrlHui from '@/assets/image/split02.png'
import imageSplitUrl from '@/assets/image/split04.png'
import imageSplitUrlHui from '@/assets/image/split03.png'
import common from '@/util/common'
import {querySubjectInfo} from '@/model/info-model'
import {listSubjectExist, queryExamInfo, querySubjectZgAndKg, queryExamSubjectDispatchType, queryExamMonitor} from '@/model/exam-manager-model'
import { queryRecognitionInfo, queryRecognitionProgress, queryScanProgressSummary } from '@/model/monitor-scan-model'
import { queryCardForExam } from '@/model/card-model'
import { queryMarkProgressSummary, queryMarkCount, countStudentSubjectInfo, setNoObjectItemOmrFinish } from '@/model/monitor-mark-model'
import {getModelInfo, getItemClass, updateItemClass, getItemsBySubject} from '@/model/item-model'
import { getTaskStatic } from '@/model/verify-model'
import {assignPJVM, importOmrScan, statOmrScore, queryExamResult,
  resultCombine, resultCombineProcess, getStatOmrScoreFlag, getStatOmrScoreProgress, clearstatOmrScoreFlag} from '@/model/pj-server-model'
import {initExamSubjectResultData, getExamSubjectGradeParam, unreleaseSubjectReport} from '@/model/report-model'

import ScoreLevelParam from './ScoreLevelParam'
import _ from 'lodash'

export default {
  data () {
    return {
      operateStatus: 0,
      submitDiabled: false,
      submitLoading: false,
      selectedCardId: '',
      menuIndex: '1',
      seaUploadUrl: '',
      total: 0,
      pageSize: 8,
      currentPage: 1,
      splitSubjectStatus: '0',
      radioExtendClass1: 'radio-wrap-active',
      radioExtendClass2: '',
      blank: '',
      imageNoSplit: imageNoSplitUrl,
      imageSplit: imageSplitUrlHui,
      subjectList: [],
      selectedItem: '',
      splitList: [{
        subjectId: '',
        omrScore: 0,
        zgScore: 0,
        omrItems: [],
        zgItems: [],
        itemVisible: false
      }],
      itemList: {
        omr: [],
        zg: []
      },
      oriItemList: {},
      itemsScoreInfo: {
        zg: [],
        omr: [],
        zgScore: 0,
        omrScore: 0,
        totalScore: 0
      },
      processText: '<div>正在进行成绩检查,请稍候...</div>',
      omrScoreProcessText: '',
      process: 0,
      subjectWorkProcess: 0,
      zgKgConfigValue: 0, // 0: 有主观和客观; 1: 只有客观; 2: 只有主观
      cardType: 0,
      reportType: 0, // 考试报表类型，0：不分文理 ，1：分文理
      timerKey: '',
      checkInfo: {
        totalCnt: 0,
        maxScore: 0,
        maxScoreCnt: 0,
        maxOmrScore: 0,
        maxOmrScoreCnt: 0,
        maxZgScore: 0,
        maxZgScoreCnt: 0,
        sigleOmrExceptionCnt: 0,
        omrScoreZeroCnt: 0,
        zgScoreOverOmrCnt: 0,
        omrScoreOverZgCnt: 0,
        studentSubjectErrorCnt: 0
      },
      checkSubjectWorkInfo: {
        scanProcess: false,
        readPaperProcess: false,
        recognitionProcess: false,
        recognitionException: false,
        setAnwserAndScore: false
      },
      gradeId: '1',
      examTag: 'weekly-exam',
      // 等级分参数
      wenliFlagText: 'none',
      wenliFlag: false,
      scoreLevel: {},
      scoreLevelParam: {
        gradeType: 0,
        gradeFlag: false, // 显示等级
        scoreFlag: false, // 显示原始分
        gradeSubjectParam: []
      },
      scoreLevelConfig: {
        gradeType: 0, // 0：分数比例，1：人数比例
        gradeFlag: true, // 显示等级
        scoreFlag: true, // 显示原始分
        levelsDataExist: {}
      },
      // omr算分状态 要成功才能进行下一步
      statOmrScoreStatus: '',
      // 测试模式 用于条件不满足不能下一步时 可以手动跳过进行下一步
      isDebug: false,
      unCheckDebugUrl: [
        '10.8.116.123',
        '127.0.0.1'
      ],
      skipSubjectCheck: false,
      // 出分跳过用
      step: {
        assignPJVM: {
          api: assignPJVM,
          cb: () => {
            this.process += 10
            this.activeEvent.stepName = '申请评卷资源'
          }
        },
        importOmrScan: {
          api: importOmrScan,
          cb: () => {
            this.process += 20
            this.activeEvent.stepName = '导入omr结果'
            this.processText += '<div>正在计算客观题成绩,请稍候...</div>'
          }
        },
        statOmrScore: {
          api: statOmrScore,
          cb: (_, param) => {
            this.process += 20
            this.activeEvent.stepName = '计算omr成绩'
            this.processText += '<div>正在合成成绩,请稍候...</div>'
            this.checkStatOmrScoreStatus(param)
          }
        },
        resultCombine: {
          api: resultCombine,
          cb: (resultCombineResult) => {
            this.process += 10
            this.activeEvent.stepName = 'OMR成绩统分'
            this.activeEvent.resultCombineResult = resultCombineResult
          }
        }
      },
      // 存下当前进行中的事件和参数 跳过的时候用
      activeEvent: {
        stepName: '',
        resultCombineResult: null
      },
      stepVisible: false,
      verifyInfo: [],
      examInfo: {},
      subjectInfo: {}
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    examName: {
      type: String,
      required: true,
      default: ''
    },
    examId: {
      type: String,
      required: true,
      default: ''
    },
    subjectId: {
      type: String,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    }
  },
  components: {
    ScoreLevelParam
  },
  computed: {
    userInfo () {
      return common.getUserInfo()
    },
    orgId () {
      return common.getUserInfo().origanization
    },
    enableScoreLevel () {
      let gradeId = parseInt(this.gradeId)
      // 高中禁用等级分，初中才开放
      if (gradeId > 9 && gradeId < 13) {
        return false
      } else {
        return true
      }
    },
    maxScoreCntUrl () {
      return this.getUrl('maxScore')
    },
    maxZgScoreCntUrl () {
      return this.getUrl('maxZgScore')
    },
    maxOmrScoreCntUrl () {
      return this.getUrl('maxOmrScore')
    },
    zgScoreOverOmrCntUrl () {
      return this.getUrl('zgScoreOverOmr')
    },
    omrScoreOverZgCntUrl () {
      return this.getUrl('omrScoreOverZg')
    },
    omrScoreZeroCntUrl () {
      return this.getUrl('omrScoreZero')
    },
    sigleOmrExceptionCntUrl () {
      return this.getUrl('sigleOmrException')
    },
    examResultAnalysisUrl () {
      return `${window.location.protocol}//${window.location.host}/view/researchLeader/objective_checked_rate.html`
    },
    recognitionUrl () {
      return `${window.location.protocol}//${window.location.host}/exam/check-view-item/${this.userInfo.userId}/${this.examId}/${this.examName}/${this.subjectId}/${this.subjectName}`
    },
    isNewGK () {
      return common.newGKTypesStrict.includes(this.examTag)
    },
    studentSubjectEditUrl () {
      return `${window.location.protocol}//${window.location.host}/exam/check-student-subject/${this.examId}`
    },
    subjectVerifyUndo () {
      if (this.verifyInfo.length === 0) return []
      let list = this.verifyInfo.filter(item => common.subjectCheckType.includes(item.checkType))
      let count = 0
      list.map(i => {
        count += i.unHandle
      })
      return count
    },
    objectVerifyUndo () {
      if (this.verifyInfo.length === 0) return []
      let list = this.verifyInfo.filter(item => common.objectCheckType.includes(item.checkType))
      let count = 0
      list.map(i => {
        count += i.unHandle
      })
      return count
    },
    scanMonitorUrl () {
      return `/monitor/${this.examId}/${this.subjectId}/scan?userId=${this.userInfo.userId}&examName=${this.examName}&examType=${this.examInfo.examType}&subjectName=${this.subjectName}&creatorOrgId=${this.examInfo.orgId}`
    }
  },
  methods: {
    openGradeMonitor () {
      let url = `/monitor/${this.examId}/${this.subjectId}/mark?userId=${this.userInfo.userId}&examName=${this.examName}&examType=${this.examInfo.examType}&subjectName=${this.subjectName}&creatorOrgId=${this.examInfo.orgId}&taskFlag=${this.subjectInfo.taskFlag}`
      window.open(url)
    },
    openScanMonitor () {
      let url = `/monitor/${this.examId}/${this.subjectId}/scan?userId=${this.userInfo.userId}&examName=${this.examName}&examType=${this.examInfo.examType}&subjectName=${this.subjectName}&creatorOrgId=${this.examInfo.orgId}`
      window.open(url)
    },
    openView (url) {
      window.open(url)
    },
    getUrl (checkType) {
      let maxType = 0
      switch (checkType) {
        case 'maxScore':
          maxType = 0
          break
        case 'maxZgScore':
          maxType = 1
          break
        case 'maxOmrScore':
          maxType = 2
          break
        case 'zgScoreOverOmr':
          maxType = 4
          break
        case 'omrScoreOverZg':
          maxType = 5
          break
        case 'omrScoreZero':
          maxType = 6
          break
        case 'sigleOmrException':
          maxType = 7
          break
      }
      // return `http://${window.location.host}/view/researchLeader/imageView.html?examId=${this.examId}&subjectId=${this.subjectId}&subjectName=${escape(this.subjectName)}&examName=${escape(this.examName)}&kgTotalScore=${this.itemsScoreInfo.omrScore}&zgTotalScore=${this.itemsScoreInfo.zgScore}&maxType=${maxType}`
      return `${window.location.protocol}//${window.location.host}/score/score-view/${this.examId}?subjectId=${this.subjectId}&subjectName=${this.subjectName}&examName=${this.examName}&kgTotalScore=${this.itemsScoreInfo.omrScore}&zgTotalScore=${this.itemsScoreInfo.zgScore}&maxType=${maxType}`
    },
    cancelSplitSubject () {
      this.radioExtendClass1 = 'radio-wrap-active'
      this.radioExtendClass2 = ''
      this.splitSubjectStatus = '0'
      this.imageNoSplit = imageNoSplitUrl
      this.imageSplit = imageSplitUrlHui
    },
    splitSubject () {
      if (!this.isNewGK) {
        this.radioExtendClass1 = ''
        this.radioExtendClass2 = 'radio-wrap-active'
        this.splitSubjectStatus = '1'
        this.imageNoSplit = imageNoSplitUrlHui
        this.imageSplit = imageSplitUrl
        this.operateStatus = 3
      }
    },
    addSplitSubject () {
      this.splitList.push({
        subjectId: '',
        omrCnt: 0,
        omrScore: 0,
        zgCnt: 0,
        zgScore: 0,
        omrItems: [],
        zgItems: []
      })
    },
    subSplitSubject (index) {
      if (this.splitList.length === 1 && index === 0) {
        this.splitList.splice(0, this.splitList.length)
        this.splitList.push({
          subjectId: '',
          omrScore: 0,
          zgScore: 0,
          omrItems: [],
          zgItems: [],
          itemVisible: false
        })
      } else {
        this.splitList.splice(index, 1)
      }
    },
    checkForgotItem () {
      this.itemList.omr.splice(0, this.itemList.omr.length)
      this.itemList.zg.splice(0, this.itemList.zg.length)
      for (let omrItem of this.oriItemList.omr) {
        let exist = false
        this.splitList.forEach((splitItem, splitIndex) => {
          for (let selectOmrItemId of splitItem.omrItems) {
            if (omrItem.itemId === selectOmrItemId) {
              exist = true
            }
          }
        })
        if (exist === false) {
          this.itemList.omr.push(omrItem)
        }
      }
      for (let zgItem of this.oriItemList.zg) {
        let exist = false
        this.splitList.forEach((splitItem, splitIndex) => {
          for (let selectZgItemId of splitItem.zgItems) {
            if (zgItem.itemId === selectZgItemId) {
              exist = true
            }
          }
        })
        if (exist === false) {
          this.itemList.zg.push(zgItem)
        }
      }
      let subjectAllSelected = true
      this.splitList.forEach((splitItem, splitIndex) => {
        if (splitItem.subjectId === '') {
          subjectAllSelected = false
        }
      })
      if ((this.itemList.omr.length + this.itemList.zg.length) > 0) {
        this.$message.error('还有未选择的题目,请检查后重试.')
        return false
      } else if (!subjectAllSelected) {
        this.$message.error('未选择要拆分的科目,请检查后重试.')
        return false
      } else {
        return true
      }
    },
    showItems (selectIndex) {
      this.itemList.omr.splice(0, this.itemList.omr.length)
      this.itemList.zg.splice(0, this.itemList.zg.length)
      for (let omrItem of this.oriItemList.omr) {
        let exist = false
        this.splitList.forEach((splitItem, splitIndex) => {
          if (selectIndex !== splitIndex) {
            for (let selectOmrItemId of splitItem.omrItems) {
              if (omrItem.itemId === selectOmrItemId) {
                exist = true
              }
            }
          }
        })
        if (exist === false) {
          this.itemList.omr.push(omrItem)
        }
      }
      for (let zgItem of this.oriItemList.zg) {
        let exist = false
        this.splitList.forEach((splitItem, splitIndex) => {
          if (selectIndex !== splitIndex) {
            for (let selectZgItemId of splitItem.zgItems) {
              if (zgItem.itemId === selectZgItemId) {
                exist = true
              }
            }
          }
        })
        if (exist === false) {
          this.itemList.zg.push(zgItem)
        }
      }
      for (let subject of this.subjectList) {
        for (let splitItem of this.splitList) {
          if (subject.subjectId === splitItem.subjectId) {
            subject.selected = true
          }
        }
      }
      this.splitList[selectIndex].itemVisible = !this.splitList[selectIndex].itemVisible
    },
    // 设置拆分科目，调用设置接口
    setSplitItemInfo () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId,
        item: []
      }
      this.splitList.forEach((splitItem, splitIndex) => {
        for (let selectZgItemId of splitItem.zgItems) {
          param.item.push({
            classname: this.getSubjectNameById(splitItem.subjectId),
            endno: selectZgItemId,
            startno: selectZgItemId,
            usersubjectid: splitItem.subjectId
          })
        }
        for (let selectZgItemId of splitItem.omrItems) {
          param.item.push({
            classname: this.getSubjectNameById(splitItem.subjectId),
            endno: selectZgItemId,
            startno: selectZgItemId,
            usersubjectid: splitItem.subjectId
          })
        }
      })
      return updateItemClass(param).then((result) => {
        this.submitLoading = false
        if (result.result.toString() === 'true') {
          this.$message({
            message: '科目拆分成功.',
            type: 'success'
          })
        }
        return result
      })
    },
    clearProcess () {
      clearInterval(this.timerKey)
      this.process = 0
    },
    // 设置进度百分比
    setProcess () {
      this.timerKey = setInterval(() => {
        if (this.process < 98) {
          this.process += 1
        } else {
          clearInterval(this.timerKey)
        }
      }, 1000 * 1)
    },
    setSubjectCheckProcess () {
      this.timerKey = setInterval(() => {
        if (this.subjectWorkProcess < 98) {
          this.subjectWorkProcess += 1
        } else {
          clearInterval(this.timerKey)
        }
      }, 1000 * 1)
    },
    // 科目检查
    async checkSubjectWork () {
      let res = await setNoObjectItemOmrFinish({
        data: {
          examId: this.examId,
          orgId: this.orgId,
          subjectId: this.subjectId
        }
      })
      if (res.result !== 'true') {
        this.$message.error(res.msg || '客观题识别状态有误')
      }
      this.operateStatus = 2
      let param = {
        data: {
          examId: this.examId,
          orgId: this.orgId,
          subjectId: this.subjectId
        }
      }
      this.setSubjectCheckProcess()
      this.processText += '<div>正在检查科目进度,请稍候...</div>'
      this.subjectWorkProcess += 10

      // 查询扫描进度
      queryScanProgressSummary(param).then(scanProcessRes => {
        this.subjectWorkProcess += 10
        if (scanProcessRes.data.progress.toString() === '100') {
          this.checkSubjectWorkInfo.scanProcess = true
        }
      }).then(() => {
        // 如果没有客观题
        if (this.zgKgConfigValue === 2) {
          this.checkSubjectWorkInfo.setAnwserAndScore = true
          this.subjectWorkProcess += 10
          this.checkReadProcess()
        } else {
        // 如果有客观题，查询科目进度,查询标答分值是否设置
          queryExamMonitor({examId: this.examId, subjectId: this.subjectId}).then((examMonitorRes) => {
            this.subjectWorkProcess += 10
            for (let monitorItem of examMonitorRes.data[0].monitorItems) {
              if (monitorItem.monitorName === '设置标答和分值' && monitorItem.monitorProcess === '1') {
                this.checkSubjectWorkInfo.setAnwserAndScore = true
              }
            }
            return examMonitorRes
          }).then((examMonitorRes) => {
            this.checkReadProcess()
          })
        }
      })
    },
    // 检查科目评卷进度
    checkReadProcess () {
      let param = {
        data: {
          examId: this.examId,
          orgId: this.orgId,
          subjectId: this.subjectId
        }
      }
      // 如果没有主观题
      if (this.zgKgConfigValue === 1) {
        this.checkSubjectWorkInfo.recognitionProcess = true
        this.checkSubjectWorkInfo.recognitionException = true
        this.checkSubjectWorkInfo.readPaperProcess = true
        this.subjectWorkProcess = 100
        // 检查科目分数
        this.checkSubjectScore()
      } else {
        // 如果是手阅卡
        if (this.cardType.toString() === '2') {
          this.checkSubjectWorkInfo.readPaperProcess = true
          // 查询手阅卡识别进度
          queryRecognitionProgress(param).then((recognitionProgressRes) => {
            this.subjectWorkProcess += 10
            if (recognitionProgressRes.data.zgRecognition.progress.toString() === '100') {
              this.subjectWorkProcess = 100
              this.checkSubjectWorkInfo.recognitionProcess = true
              this.checkSubjectWorkInfo.recognitionException = true
              // 识别完成，检查科目分数
              this.checkSubjectScore()
            } else {
              // 查询手阅卡识别异常
              let param = {data: {
                examId: this.examId,
                organizationId: this.orgId,
                searchInfo: {clazzId: '', zgRecognitionStatus: '5', searchCondition: ''},
                subjectId: this.subjectId,
                pageNum: 1,
                pageSize: 10
              }}
              queryRecognitionInfo(param).then((recognitionInfoRes) => {
                if (recognitionInfoRes.data.length === 0) {
                  this.checkSubjectWorkInfo.recognitionException = true
                }
                this.checkSubjectScore()
              })
            }
          })
        } else {
          this.checkSubjectWorkInfo.recognitionException = true
          this.checkSubjectWorkInfo.recognitionProcess = true
          // 查询任务分配类型
          queryExamSubjectDispatchType({data: {examId: this.examId}}).then((dispatchTypeRes) => {
            this.subjectWorkProcess += 10
            return dispatchTypeRes
          }).then((dispatchTypeRes) => {
            this.subjectWorkProcess += 10
            let param = {
              data: {
                examId: this.examId,
                subjectId: this.subjectId,
                orgId: this.orgId,
                taskFlag: dispatchTypeRes.data[0].taskFlag,
                userOrgId: this.orgId
              }
            }
            queryMarkCount({
              data: {
                examId: this.examId,
                subjectId: this.subjectId,
                orgId: this.orgId
              }
            }).then((markCountRes) => {
              if (markCountRes.result.toString() === 'true') {
                if (markCountRes.data.markCount === markCountRes.data.scanItemCount) {
                // 查询评卷进度
                  queryMarkProgressSummary(param).then(markProcessRes => {
                    if (markProcessRes.data.markProgress.toString() === '100') {
                      this.checkSubjectWorkInfo.readPaperProcess = true
                      this.subjectWorkProcess = 100
                    // 评卷完成，检查科目分数
                    }
                    this.checkSubjectScore()
                  })
                } else {
                  this.checkSubjectWorkInfo.readPaperProcess = false
                  this.checkSubjectScore()
                }
              } else {
                // 可能没有主观题
                this.subjectWorkProcess = 100
                this.checkSubjectScore()
              }
            }, () => {
              this.subjectWorkProcess = 0
              this.clearProcess()
              this.processText += "<div style='color: red;'>检查科目进度失败</div>"
              this.submitLoading = false
            })
          })
        }
      }
    },
    // 成绩检查
    async checkSubjectScore () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      let subjectWork = true
      for (let subjectWorkItem in this.checkSubjectWorkInfo) {
        if (!this.checkSubjectWorkInfo[subjectWorkItem]) {
          subjectWork = false
        }
      }
      if (subjectWork || this.skipSubjectCheck) {
        this.setProcess()
        this.processText += '<div>正在导入OMR成绩,请稍候...</div>'
        this.process += 10
        if (this.zgKgConfigValue === 1) {
        // 如果只有客观题, 则需要手动调用接口(申请评卷虚拟机)
          param.forceExamUintUrl = true
          this.activeEvent.stepName = '申请评卷资源'
          assignPJVM(param).then((pvmResult) => {
            this.activeEvent.stepName = '导入omr结果'
            if (pvmResult.result.toString() === 'true') {
              this.process += 10
              // 导入omr结果
              importOmrScan(param).then((importResult) => {
                this.activeEvent.stepName = '计算omr成绩'
                this.process += 20
                this.processText += '<div>正在计算客观题成绩,请稍候...</div>'
                return importResult
              }).then((importResult) => {
                if (!importResult.result || importResult.result.toString() !== 'true') {
                  this.$message.error(importResult.errorMsg || '计算客观题成绩失败!')
                  this.submitLoading = false
                  this.processText += `<div style='color: red;'>计算客观题成绩失败 - ${importResult.errDesc || importResult.errorMsg}, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
                  this.process = 0
                  return
                }
                // 计算omr成绩
                statOmrScore(param).then((statOmrScoreResult) => {
                  if (!statOmrScoreResult || !statOmrScoreResult.result || statOmrScoreResult.result === 'false') {
                    this.$message.error('计算omr成绩失败!')
                    this.submitLoading = false
                    this.processText += `<div style='color: red;'>计算omr成绩失败, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
                    this.process = 0
                    return
                  }
                  this.process += 10
                  this.processText += '<div>正在合成成绩,请稍候...</div>'
                  this.activeEvent.stepName = 'OMR成绩统分'
                  return this.checkStatOmrScoreStatus(param, this.checkResultCombine)
                }, () => {
                  this.activeEvent.step = 'resultCombine'
                  this.processText += "<div style='color: red;'>合成成绩失败</div>"
                  this.submitLoading = false
                  this.process = 0
                })
              }, () => {
                this.$message.error('计算客观题成绩失败!')
                this.submitLoading = false
                this.processText += `<div style='color: red;'>计算客观题成绩失败, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
                this.process = 0
              })
            }
          }, () => {
            this.$message.error('导入omr结果失败!')
            this.submitLoading = false
            this.processText += `<div style='color: red;'>导入omr结果失败</div>`
            this.process = 0
          })
        } else {
          this.activeEvent.stepName = '导入omr结果'
          // 导入omr结果
          importOmrScan(param).then((importResult) => {
            this.activeEvent.stepName = '计算omr成绩'
            this.process += 20
            this.processText += '<div>正在计算客观题成绩,请稍候...</div>'
            return importResult
          }).then((importResult) => {
            if (!importResult.result || importResult.result.toString() !== 'true') {
              this.$message.error(importResult.errorMsg || '计算客观题成绩失败!')
              this.submitLoading = false
              this.processText += `<div style='color: red;'>计算客观题成绩失败 - ${importResult.errDesc || importResult.errorMsg}, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
              this.process = 0
              return
            }
            // 计算omr成绩
            statOmrScore(param).then((statOmrScoreResult) => {
              if (!statOmrScoreResult || !statOmrScoreResult.result || statOmrScoreResult.result === 'false') {
                this.$message.error('计算omr成绩失败!')
                this.submitLoading = false
                this.processText += `<div style='color: red;'>计算omr成绩失败, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
                this.process = 0
                return
              }
              this.process += 10
              this.processText += '<div>正在合成成绩,请稍候...</div>'
              this.activeEvent.stepName = 'OMR成绩统分'
              return this.checkStatOmrScoreStatus(param, this.checkResultCombine)
            }, () => {
              this.activeEvent.step = 'resultCombine'
            })
          })
        }
      } else {
        this.operateStatus = 5
        this.submitLoading = false
      }
    },
    // statOmrScore 计算omr成绩要很久 改成异步的 通过getStatOmrScoreFlag查完成状态, getStatOmrScoreProgress查执行日志, 成功了再执行下一步
    checkStatOmrScoreStatus (param, successCallBack) {
      getStatOmrScoreFlag(param).then(res => {
        this.statOmrScoreStatus = res.data
        return getStatOmrScoreProgress(param)
      }).then(res => {
        if (res) {
          this.omrScoreProcessText = res.split('\n').map(i => `<div>${i}</div>`).join(' ')
        }
        this.$nextTick(() => {
          this.$refs.omrScoreProcessText.scrollTop = this.$refs.omrScoreProcessText.scrollHeight
        })
        // 如果关闭了出成绩的弹窗就不再请求了
        if (this.operateStatus !== 2) return
        if (this.statOmrScoreStatus !== 'success') {
          setTimeout(() => {
            this.checkStatOmrScoreStatus(param, successCallBack)
          }, 2000)
        } else {
          successCallBack && successCallBack(param)
        }
      }).catch(() => {
        this.$message.error('计算omr成绩失败!')
        this.submitLoading = false
        this.processText += `<div style='color: red;'>计算omr成绩失败, <p><a href="${this.scanMonitorUrl}">请前往扫描监控处做客观题校验的omr码不规范数据校验</a><br ><span>如有疑问请前往帮助手册查看 3.14 清除客观题识别结果重新识别</span></p></div>`
        this.process = 0
      })
    },
    checkResultCombine (param) {
      resultCombine(param).then((resultCombineResult) => {
        this.process += 10
        this.activeEvent.stepName = '完成'
        this.activeEvent.resultCombineResult = resultCombineResult
        return resultCombineResult
      }).then((resultCombineResult) => {
        this.checkResultCombineProcess(resultCombineResult)
      })
    },
    async setEvent (step) {
      if (step === 'importOmrScan') {
        let res = await setNoObjectItemOmrFinish({
          data: {
            examId: this.examId,
            orgId: this.orgId,
            subjectId: this.subjectId
          }
        })
        if (res.result !== 'true') {
          this.$message.error(res.msg || '客观题识别状态有误')
        }
      }
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      this.step[step].api(param).then((res) => {
        if (res.result === 'true' || step === 'resultCombine') {
          this.step[step].cb(res, param)
          this.$message.success(`${this.activeEvent.stepName}成功`)
        } else if (res.result === 'false') {
          this.$alert(res.errDesc, '温馨提示')
          this.processText += `<div>${this.activeEvent.stepName} - ${res.errDesc || res.errorMsg || '错误'}</div>`
        }
      }, (err) => {
        console.log(err)
        this.$alert(`${this.activeEvent.stepName}失败`, '温馨提示')
      })
    },
    handleSkip () {
      this.stepVisible = true
    },
    clearstatOmrScoreFlag () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      clearstatOmrScoreFlag(param).then(res => {
        if (res.result === 'true') {
          this.$message.success('重置成功!')
        } else {
          this.$message.error('重置失败!' + res.errDesc)
        }
      })
    },
    checkResultCombineProcess (resultCombineResult) {
      if (!resultCombineResult) {
        this.$message.error('请先OMR成绩统分后查询!')
        return
      }
      setTimeout(() => {
        resultCombineProcess(resultCombineResult).then((combinProcess) => {
          if (combinProcess.data[2].indexOf('失败') > -1) {
            this.clearProcess()
            this.$message.error('成绩合成失败.')
            this.processText += `<div style='color: red;'>成绩合成失败-${combinProcess.data[2]}</div>`
            this.process = 0
            this.submitLoading = false
          } else if (combinProcess.data[0] === combinProcess.data[1]) {
            this.$message({
              message: '成绩合成完成.',
              type: 'success'
            })
            this.processText += `<div>成绩合成完成</div>`
            this.process = 100
            setTimeout(() => {
              this.operateStatus = 4
              this.checkResult()
              this.submitLoading = false
            }, 1000)
          } else {
            this.checkResultCombineProcess(resultCombineResult)
          }
        })
      }, 1000)
    },
    computeSplitSubjectScore (index, itemInfo) {
      if (itemInfo && itemInfo !== 'omr') {
        let selectedItemGroupId = itemInfo.itemGroupId
        if (selectedItemGroupId !== '0') {
          for (let zg of this.itemList.zg) {
            if (zg.itemGroupId === itemInfo.itemGroupId && zg.itemId !== itemInfo.itemId) {
              let itemIndex = this.splitList[index].zgItems.indexOf(zg.itemId)
              if (itemIndex === -1) {
                this.splitList[index].zgItems.push(zg.itemId)
              } else {
                this.splitList[index].zgItems.splice(itemIndex, 1)
              }
            }
          }
        }
      }

      this.splitList[index].omrScore = 0
      this.splitList[index].zgScore = 0
      for (let selectedOmr of this.splitList[index].omrItems) {
        for (let omr of this.itemsScoreInfo.omr) {
          if (selectedOmr === omr.itemId.toString()) {
            this.splitList[index].omrScore += omr.score
          }
        }
      }
      for (let selecedZg of this.splitList[index].zgItems) {
        for (let zg of this.itemsScoreInfo.zg) {
          if (selecedZg === zg.itemId.toString()) {
            this.splitList[index].zgScore += zg.score
          }
        }
      }
    },
    calcGradeLevel (gradeCode) {
      let code = parseInt(gradeCode, 10)
      let level = ''
      if (isNaN(code)) {
        level = 'unknow'
      } else {
        if (code <= 0 || code > 12) {
          level = 'unknow'
        } else if (code < 7) {
          level = 'primary'
        } else if (code < 10) {
          level = 'junior'
        } else {
          level = 'high'
        }
      }
      return level
    },
    getSubjectNameById (subjectId) {
      let subjectName = ''
      for (let subject of this.subjectList) {
        if (subject.subjectId === subjectId) {
          subjectName = subject.subjectName
        }
      }
      return subjectName
    },
    setLevelParamConfig () {
      console.log('setLevelParamConfig')
      let promise = this.$refs['ScoreGradeLevel'].fetchScoreLevel()
      return promise.then((levelParam) => {
        this.scoreLevelParam = {
          gradeType: levelParam.levelType,
          gradeFlag: levelParam.levelFlag, // 显示等级
          scoreFlag: levelParam.scoreFlag, // 显示原始分
          gradeSubjectParam: []
        }
        // 判断文理分科
        let keys = ['levelsData']
        if (this.wenliFlag) {
          switch (this.wenliFlagText) {
            case 'none':
              keys = ['levelsDataWen', 'levelsDataLi']
              break
            case 'arts':
              keys = ['levelsDataWen']
              break
            case 'science':
              keys = ['levelsDataWen']
              break
          }
        }
        for (let key of keys) {
          let tempArray = {
            gradeParamArray: [],
            wenliType: this.wenliFlagText
          }
          console.log(levelParam, keys, key, levelParam[key])

          for (let levelIndex = 0; levelIndex < levelParam[key].length; levelIndex++) {
            let tempSegmentValue = ''
            let levelObject = levelParam[key][levelIndex]
            // 第一个段位
            if (levelIndex === 0) {
              tempSegmentValue = `[${levelObject.percent},100]`
            // 最后一个段位
            } else if (levelIndex === levelParam[key].length - 1) {
              tempSegmentValue = `[0,${levelParam[key][levelIndex - 1].percent})`
            } else {
              tempSegmentValue = `[${levelObject.percent},${levelParam[key][levelIndex - 1].percent})`
            }
            tempArray.gradeParamArray.push({
              segmentKey: levelParam[key][levelIndex].levelName,
              segmentValue: tempSegmentValue
            })
          }
          this.scoreLevelParam.gradeSubjectParam.push(tempArray)
        }
        console.log(this.scoreLevelParam)
        // 检查参数是否发生变化
        if (this.scoreLevelConfigExist) {
          if (levelParam.levelType.toString() !== this.scoreLevelConfig.gradeType.toString() ||
          levelParam.levelFlag.toString() !== this.scoreLevelConfig.gradeFlag.toString() ||
          levelParam.scoreFlag.toString() !== this.scoreLevelConfig.scoreFlag.toString()) {
            this.$confirm('等级分设置已修改，您需要重新生成其它所有科目的成绩, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              unreleaseSubjectReport({
                data: {
                  examId: this.examId
                }
              }).then(res => {
                if (res.result === 'true') {
                  this.checkSubjectWork()
                }
              })
            }).catch((ex) => {
              console.log(ex)
              this.submitLoading = false
              this.$refs['ScoreGradeLevel'].recoverConfig()
              this.scoreLevelParam.gradeType = this.scoreLevelConfig.gradeType
              this.scoreLevelParam.gradeFlag = this.scoreLevelConfig.gradeFlag// 显示等级
              this.scoreLevelParam.scoreFlag = this.scoreLevelConfig.scoreFlag // 显示原始分
            })
          } else {
            this.checkSubjectWork()
          }
        } else {
          console.log('成绩计算')
          this.checkSubjectWork()
        }
      })
    },
    // 获取当前科目的文理属性
    getCurrentWenLiFlag () {
      if (this.reportType.toString() !== '0') {
        this.wenliFlag = true
        let wenLiName = this.subjectList.find((subject, index) => {
          return subject.subjectId === this.subjectId
        }).wenLiName
        switch (wenLiName) {
          case '理科':
            this.wenliFlagText = 'science'
            break
          case '文科':
            this.wenliFlagText = 'arts'
            break
        }
      }
      // test
      // this.wenliFlag = true
      // this.wenliFlagText = 'none'
    },
    // 查询等级分参数
    getExamGradeParamData () {
      getExamSubjectGradeParam({
        data: {
          examId: this.examId,
          subjectId: this.subjectId
        }
      }).then(scoreLevelParam => {
        if (scoreLevelParam.result.toString() === 'true') {
          this.submitLoading = false
          if (scoreLevelParam.data.gradeFlag !== null) {
            this.scoreLevelConfigExist = true
            this.scoreLevelConfig.gradeFlag = scoreLevelParam.data.gradeFlag
            this.scoreLevelConfig.gradeType = scoreLevelParam.data.gradeType
            this.scoreLevelConfig.scoreFlag = scoreLevelParam.data.scoreFlag
            this.scoreLevelConfig.levelsDataExist = scoreLevelParam.data.gradeSubjectParam ? scoreLevelParam.data.gradeSubjectParam[0] : []
            this.$refs.ScoreGradeLevel.recoverConfig()
          }
        }
      })
    },
    submit () {
      this.submitLoading = true
      // 不拆分直接合分
      if (this.operateStatus === 0) {
        if (this.splitSubjectStatus === '0') {
          // 清除拆分结果
          updateItemClass({
            examId: this.examId,
            subjectId: this.subjectId,
            item: []
          }).then((result) => {
            if (result.result.toString() === 'true') {
              // 跳转到等级分设置
              this.submitLoading = false
              this.operateStatus = 1
              this.$nextTick().then(() => {
                this.getExamGradeParamData()
              })
            }
          })
        } else {
          // 跳转到等级分设置
          this.submitLoading = false
          this.operateStatus = 1
          this.$nextTick().then(() => {
            this.getExamGradeParamData()
          })
        }
      } else if (this.operateStatus === 1) {
        this.setLevelParamConfig().catch(() => {
          this.submitLoading = false
        })
      } else if (this.operateStatus === 3) {
        if (this.checkForgotItem()) {
          this.setSplitItemInfo().then(() => {
            // 跳转到等级分设置
            this.operateStatus = 1
            this.$nextTick().then(() => {
              this.getExamGradeParamData()
            })
          })
        } else {
          this.submitLoading = false
        }
      } else if (this.operateStatus === 4) {
        if (this.isNewGK && this.checkInfo.studentSubjectErrorCnt > 0) {
          this.$message({
            message: '有考生的选考科目数不等于6科，请修改后重试',
            type: 'error'
          })
          return
        }
        this.submitLoading = true
        initExamSubjectResultData({data: {
          examId: this.examId,
          subjectId: this.subjectId,
          examName: this.examName,
          subjectName: this.subjectName,
          userId: this.userInfo.userId,
          gradeParam: this.scoreLevelParam,
          reInit: true}}).then((res) => {
          this.submitLoading = false
          if (res.result.toString() === 'true') {
            this.$message({
              message: '操作成功,可以点击右上角任务按钮查看上报进度.',
              type: 'success'
            })
            setTimeout(() => {
              this.handleClose()
            }, 1000)
          } else {
            if (res.errorMsg === '剩余次数归零') {
              this.$message({
                message: '您账号中的阅卷次数已用完，请联系在线客服进行续费.',
                type: 'error'
              })
            } else {
              this.$message({
                message: res.errorMsg,
                type: 'error'
              })
            }
          }
        })
      } else if (this.operateStatus === 4) {
        this.handleClose()
      }
    },
    // 成绩核查
    checkResult () {
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'MaxScoreAndCount'
      }).then((res) => {
        this.checkInfo.maxScore = res.data.maxScore
        this.checkInfo.maxScoreCnt = res.data.maxScoreCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'KgMaxScoreAndCount'
      }).then((res) => {
        this.checkInfo.maxOmrScore = res.data.kgMaxScore
        this.checkInfo.maxOmrScoreCnt = res.data.kgMaxScoreCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'ZgMaxScoreAndCount'
      }).then((res) => {
        this.checkInfo.maxZgScore = res.data.zgMaxScore
        this.checkInfo.maxZgScoreCnt = res.data.zgMaxScoreCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'TotalCount'
      }).then((res) => {
        this.checkInfo.totalCnt = res.data.totalCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'KgAnsweredButZero'
      }).then((res) => {
        this.checkInfo.omrScoreZeroCnt = res.data.kgAnsweredButZero
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'SingleDivButMultiAnswered'
      }).then((res) => {
        this.checkInfo.sigleOmrExceptionCnt = res.data.singleDivButMultiAnswered
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        zgTotalScore: this.itemsScoreInfo.zgScore,
        kgTotalScore: this.itemsScoreInfo.omrScore,
        flag: 'ZgHighAndKgLowCount'
      }).then((res) => {
        this.checkInfo.zgScoreOverOmrCnt = res.data.zgHighAndKgLowCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        zgTotalScore: this.itemsScoreInfo.zgScore,
        kgTotalScore: this.itemsScoreInfo.omrScore,
        flag: 'KgHighAndZgLowCount'
      }).then((res) => {
        this.checkInfo.omrScoreOverzgCnt = res.data.kgHighAndZgLowCount
      })
      queryExamResult({
        examId: this.examId,
        subjectId: this.subjectId,
        flag: 'examResultAnalysis'
      }).then((res) => {
        sessionStorage.setItem('objective_answer_rate', JSON.stringify(res.data))
      })
      getTaskStatic({
        examId: this.examId,
        subjectId: this.subjectId
      }).then((res) => {
        this.verifyInfo = res.data
      })
      if (this.isNewGK) {
        countStudentSubjectInfo({data: {
          examId: this.examId,
          searchStudentCondition: '',
          searchSubjectCondition: {
            symbol: '<',
            num: 6
          },
          pageSize: 10000,
          pageNum: 1
        }}).then((res) => {
          this.checkInfo.studentSubjectErrorCnt = res.data.count
        })
      }
    },
    handleClose (done) {
      this.process = 0
      this.subjectWorkProcess = 0
      // 不调用 done, 而应该让父组件去关闭弹窗
      for (let splitItem of this.splitList) {
        splitItem.itemVisible = false
      }
      if (this.operateStatus === 4) {
        this.operateStatus = 0
        this.processText = '<div>正在进行成绩检查,请稍候...</div>'
        this.$emit('dialog-close')
      } else {
        this.operateStatus = 0
        this.processText = '<div>正在进行成绩检查,请稍候...</div>'
        this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
      }
      document.removeEventListener('keydown', this.handleGlobalEvent, true)
    },
    checkOmrScoreStatus () {
      if (this.unCheckDebugUrl.includes(location.hostname)) {
        this.isDebug = true
      }
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      getStatOmrScoreFlag(param).then(res => {
        if (res.data === 'init') {
          this.$message({
            message: 'OMR计算成绩正在处理中.',
            type: 'warning'
          })
          this.process = 20
          this.operateStatus = 2
          this.processText += '<div>正在合成成绩,请稍候...</div>'
          this.activeEvent.stepName = 'OMR成绩统分'
          this.submitLoading = true
          this.checkStatOmrScoreStatus(param, this.checkResultCombine)
        }
      })
    },
    initData () {
      listSubjectExist({data: {examId: this.examId}}).then((existSubjects) => {
        for (let subject of existSubjects.data) {
          if (subject.subjectId === this.subjectId) {
            if (subject.subjectStatus === '2') {
              this.$message({
                message: '科目成绩正在处理中.',
                type: 'warning'
              })
              this.submitDiabled = true
            } else {
              this.submitDiabled = false
              this.submitLoading = false
              console.log(this.submitLoading)
              queryExamInfo({data: {examId: this.examId}}).then(examInfo => {
                this.gradeId = examInfo.data.examInfo.gradeId
                this.reportType = examInfo.data.examInfo.reportType
                this.examTag = examInfo.data.examInfo.examProperty[3]
                if (this.isNewGK) {
                  this.radioExtendClass2 = 'radio-wrap-disabled'
                }
                this.examInfo = examInfo.data.examInfo
                this.subjectInfo = examInfo.data.subject.find(i => i.subjectId === this.subjectId)
                // 由于高中不能用，所有暂时屏蔽文理
                // this.getCurrentWenLiFlag()
                return examInfo
              }).then((examInfo) => {
                getItemClass({
                  examId: this.examId,
                  subjectId: this.subjectId
                }).then((itemClass) => {
                  if (itemClass.length > 0) {
                    this.splitSubjectStatus = '1'
                    this.radioExtendClass1 = ''
                    this.radioExtendClass2 = 'radio-wrap-active'
                    this.imageNoSplit = imageNoSplitUrlHui
                    this.imageSplit = imageSplitUrl
                    this.splitList.splice(0, this.splitList.length)
                  }
                  let splitedSubjectIds = []
                  for (let splitItem of itemClass) {
                    if (splitedSubjectIds.indexOf(splitItem.usersubjectid) === -1) {
                      splitedSubjectIds.push(splitItem.usersubjectid)
                    }
                  }
                  querySubjectInfo({origanizationId: this.userInfo.origanization,
                    level: this.calcGradeLevel(examInfo.data.examInfo.gradeId)}).then((subjectList) => {
                    this.subjectList.splice(0, this.subjectList.length)
                    for (let subject of subjectList) {
                      if (subject.subjectId !== this.subjectId) {
                        this.subjectList.push({
                          subjectId: subject.subjectId,
                          subjectCode: subject.subjectCode,
                          subjectName: subject.subjectName,
                          wenLiName: subject.type,
                          selected: false
                        })
                      }
                    }
                    for (let splitedSubjectId of splitedSubjectIds) {
                      for (let subject of this.subjectList) {
                        if (splitedSubjectId === subject.subjectId) {
                          subject.selected = true
                        }
                      }
                    }
                  })
                  getModelInfo({
                    examId: this.examId,
                    subjectId: this.subjectId
                  }).then((cardRes) => {
                    this.itemList.omr.splice(0, this.itemList.omr.length)
                    this.itemList.zg.splice(0, this.itemList.zg.length)
                    for (let omr of cardRes.omr) {
                      this.itemList.omr.push({
                        itemId: omr.Item_Id,
                        itemText: '题' + omr.Item_Id
                      })
                    }
                    for (let zg of cardRes.zg) {
                      this.itemList.zg.push({
                        itemId: zg.Item_Id,
                        itemText: '题' + zg.Item_Id,
                        itemGroupId: zg.group
                      })
                    }
                    this.oriItemList = _.cloneDeep(this.itemList)
                    return cardRes
                  }).then((cardRes) => {
                    for (let subjectId of splitedSubjectIds) {
                      let tempSplitObject = {
                        subjectId: subjectId,
                        omrScore: 0,
                        zgScore: 0,
                        omrItems: [],
                        zgItems: [],
                        itemVisible: false
                      }
                      for (let splitItem of itemClass) {
                        if (splitItem.usersubjectid === subjectId) {
                          for (let zg of cardRes.zg) {
                            if (splitItem.startno.toString() === zg.Item_Id.toString()) {
                              tempSplitObject.zgItems.push(splitItem.startno.toString())
                            }
                          }
                          for (let omr of cardRes.omr) {
                            if (splitItem.startno.toString() === omr.Item_Id.toString()) {
                              tempSplitObject.omrItems.push(splitItem.startno.toString())
                            }
                          }
                        }
                      }
                      this.splitList.push(tempSplitObject)
                    }
                    return cardRes
                  }).then((cardRes) => {
                    getItemsBySubject({data: { examId: this.examId,
                      subjectId: this.subjectId }}).then((itemsInfo) => {
                      if (itemsInfo.result === 'true') {
                        this.itemsScoreInfo.omrScore = 0
                        this.itemsScoreInfo.zgScore = 0
                        this.itemsScoreInfo.totalScore = 0
                        this.itemsScoreInfo.omr.splice(0, this.itemsScoreInfo.omr.length)
                        this.itemsScoreInfo.zg.splice(0, this.itemsScoreInfo.zg.length)
                        for (let item of itemsInfo.data) {
                          if (item.type === 'omr') {
                            for (let omr of item.questionList) {
                              this.itemsScoreInfo.omr.push({
                                itemId: omr.name,
                                score: parseFloat(omr.score)
                              })
                              this.itemsScoreInfo.omrScore += parseFloat(omr.score)
                            }
                          } else if (item.type === 'zg') {
                            this.itemsScoreInfo.zg.push({
                              itemId: item.name,
                              score: parseFloat(item.fullscore)
                            })
                            this.itemsScoreInfo.zgScore += parseFloat(item.fullscore)
                          }
                        }
                        this.itemsScoreInfo.totalScore = this.itemsScoreInfo.zgScore + this.itemsScoreInfo.omrScore
                        for (let index in this.splitList) {
                          this.computeSplitSubjectScore(index)
                        }
                      }
                    })
                  }).catch(ex => {
                    this.$message.error('查询题目信息失败')
                  })
                })
              })
              // 检查主客观设置情况
              querySubjectZgAndKg({data: {
                examId: this.examId,
                subjectId: this.subjectId
              }}).then((zgKgConfigResult) => {
                if (zgKgConfigResult.result.toString() === 'true') {
                  this.zgKgConfigValue = parseInt(zgKgConfigResult.data.configValue, 10)
                } else {
                  this.$message.error('科目主客观题目信息查询失败')
                  this.submitDiabled = true
                }
              })
              // 查询考试使用的在线题卡ID 0:纸质卡,1,在线题卡，2，手阅卡
              queryCardForExam({examid: this.examId,
                subjectid: this.subjectId,
                orgid: this.orgId}).then((cardInfoRes) => {
                if (cardInfoRes.data.paperType) {
                  this.cardType = cardInfoRes.data.paperType
                } else {
                  this.cardType = '0'
                }
              })
            }
          }
        }
      })
    },
    dialogOpen () {
      document.addEventListener('keydown', this.handleGlobalEvent, true)
      this.checkOmrScoreStatus()
      this.initData()
      this.skipSubjectCheck = false
    },
    handleGlobalEvent (event) {
      if (event.key.toLowerCase() === 'b' && event.altKey) {
        this.$prompt('请输入密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          if (value === common.debug_password) {
            this.isDebug = true
          } else {
            this.$message.error('密码错误!')
          }
        }).catch(() => {})
        event.preventDefault()
        event.returnValue = false
        return false
      }
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleGlobalEvent, true)
    this.checkOmrScoreStatus()
    this.initData()
  },
  watch: {
    splitList: {
      handler: function (val, oldVal) {
        for (let subject of this.subjectList) {
          subject.selected = false
          for (let splitItem of this.splitList) {
            if (subject.subjectId === splitItem.subjectId) {
              subject.selected = true
            }
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.item-list-wrap{
  $border-color: #D8D8C9;
  display: flex;
  width: 830px;
  height: 300px;
  // flex-direction: column;
  flex-wrap: wrap;
  overflow-y: auto;
  justify-content: center;
  padding-bottom: 10px;
  .item-list-title{
    display: flex;
    height: 36px;
    justify-content: space-between;
    width: 776px;
    min-height: 36px;
    align-items: center;
  }
  .item-list{
    display: flex;
    width: 776px;
    flex-wrap: wrap;
    border: 1px solid $border-color;
    align-content: start;
    .item{
      width: 96px;
      border-right: 1px solid $border-color;
      border-bottom: 1px solid $border-color;
      display: flex;
      justify-content: center;
      align-items: center;
      max-height: 40px;
      min-height: 40px;
    }
    .item:hover{
      background:#DFFFBF;
    }
  }
}
.main-container{
  $border-color: #D8D8C9;
  border: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  width: 100%;
  // height: 500px;

  .subject-wrap{
    width: 112px;
    input{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .tip-wrap{
    height: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    .tip-text-wrap{
      margin-left: 100px;
      height: 90px;
      .tip-text{
        color: $color-label;
        font-size: 26px;
      }
      .tip-text-small{
        color: $color-text-hui;
        font-size: 15px;
        margin-top:30px;
      }
    }

  }
  .radio-oprate-wrap{
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    .radio-wrap{
      height: 200px;
      width: 320px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: $border-color 1px solid;
      color: $color-text-hui;
      cursor: pointer;
      .radio-wrap-inner{
        display: flex;
        height: 50px;
        align-items: flex-end;
        .tip-text-big{
          font-size: 22px;
          font-weight: bolder;
        }
        .tip-text-subject{
          margin-left: 10px;
        }
      }
    }
    .radio-wrap-active{
      color: $color-label;
      border-color: $color-label;
    }
    .radio-wrap:hover{
      color: $color-label;
      border-color: $color-label;
    }
    .radio-wrap-disabled{
      border: $border-color 1px solid;
      color: $color-text-hui;
      &:hover{
        border: $border-color 1px solid;
        color: $color-text-hui;
        cursor:not-allowed;
      }
    }
  }
  .split-list-container{
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 500px;
    .split-row{
      display: flex;
      height: 80px;
      min-height: 80px;
      border-bottom: 1px solid $border-color;
      margin-left: 20px;
      width: 96%;
      align-items: center;
      .split-oprate-wrap{
        padding-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .split-oprate{
          display: flex;
          justify-content:space-around;
          align-items: center;
          padding-left: 15px;
          border-left: 1px solid;
          margin-left: 10px;
          height: 34px;
          color:$color-label;
          width: 80px;
          .split-add{
            border: 1px solid;
            border-radius: 33px;
            height: 26px;
            width: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          .split-add:hover{
            background: $color-label;
            color: white;
          }
        }
      }
      .split-items-info{
        display: flex;
        background-color: #F0F0F0;
        height: 34px;
        color: $text-color;
        /* justify-content: center; */
        align-items: center;
        width: 430px;
        border: 1px solid $border-color;
        padding-left: 10px;
        margin-left: 10px;
      }
    }

  }
  .process-wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    .process-bottom{
      width: 260px;
      height: 190px;
      background: #b5b5b5;
      border-radius: 113px;
      transform: rotateX(268deg);
      margin-top: -86px;
    }
  }
  .check-info-wrap{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    .title-wrap{
      display: flex;
      align-items: center;
      height: 65px;
      padding-left: 20px;
      border-bottom: 1px solid $border-color;
    }
    .info-wrap{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;
      box-sizing: border-box;
      width: 100%;
      height: 430px;
      .info-item {
        height: 100px;
        margin-top: 3px;
        width: 85%;
        display: flex;
        flex-direction: column;
        .info-item-title{
          border-left: 5px solid #FF7F00;
          height: 20px;
          width: 100%;
          padding-left: 10px;
          font-size: 15px;
          font-weight: bolder;
          display: flex;
          align-items: center;
        }
        .info-item-content{

          display: flex;
          padding-left: 13px;
          height: 50px;
          align-items: center;
          .info-item-content-tip{
            color:$color-text-hui;
            font-size: 12px;
          }
        }
        .person-num{
          color:$color-label;
        }
      }
      .check-subject-item-wrap{
        width: 100%;
        height: 70px;
        border-bottom: 1px solid $border-color;
        display: flex;
        justify-content: flex-start;
        .check-subject-item{
          padding-left: 20px;
          height: 100%;
          width: 200px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/task/generate-subject-score/GenerateSubjectScore.vue